import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  items: [],
  isLoading: false,
  error: false,
  item: {},
  docs: [],
  isDownloading: false,
  errorDownloading: false,
  isUploading: false,
  errorUploading: false,
  prices: [],
  isLoadingPrice: false,
  errorPrice: false,
  isLoadingInvoice: false,
  errorInvoice: false,
  invoices: [],
  isUploaded: false,
  isLoadingDoc: false,
  errorDoc: false,
  isPostingReq: false,
  isSuccessfulReq: false,
  erroReq: false,
  otif: [],
  errorOtif: false,
  otifIsLoading: false,
  // leadtime
  leadTimeItem: {},
  isLeadTimeLoading: false,
  isLeadtimeError: false,
  // update details
  isUpdating: false,
  isUpdated: {},
  errorUpdate: false,
  // download price detail
  downloadPriceDetail: {},
  errorDownloadPriceDetail: false,
  isLoadingDownloadPriceDetail: false,
  // history manage shipment
  history: [],
  isLoadingHistory: false,
  errorHistory: false,
  // active user
  activeUser: [],
  isLoadingActiveUser: false,
  errorActiveUser: false,
  // pending user
  pendingUser: [],
  isLoadingPendingUser: false,
  errorPendingUser: false,

  getDelayLog: [],
  isLoadingGetDelayLog: false,
  isErrorGetDelayLog: false,
  // filter shipment
  getFilterShipment: [],
  errorGetFilterShipment: false,
  isLoadingGetFilterShipment: false,

  downloadEfbl: {},
  errorDownloadEfbl: false,
  isLoadingDownloadEfbl: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/shipment/index.js